/**
 * A changed part of an entity's definition (`AcquisitionHistory.changedParts`) in words: `inputSchema` → "input
 * schema". Pure — the client's updates page and the conversation card both show it, and this file imports nothing so
 * either can load it.
 *
 * Import via: @confluent/shared/lib/marketplace/changed-part-label
 */
export function changedPartLabel(part: string): string {
  return part.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
}
